/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as InlineEditDefault } from './inline-edit-default.story';
export { default as InlineEditHeader } from './inline-edit-header.story';
export { default as InlineEditControlledEditing } from './inline-edit-controlled-editing.story';
export { default as InlineEditWithEditIcon } from './inline-edit-with-edit-icon.story';
export { default as InlineEditDisabled } from './inline-edit-disabled.story';
export { default as InlineEditWithPlaceholder } from './inline-edit-with-placeholder.story';
export { default as InlineEditNoConfirmOnBlur } from './inline-edit-no-confirm-on-blur.story';
export { default as InlineEditControlledValue } from './inline-edit-controlled-value.story';
export { default as InlineEditFluid } from './inline-edit-fluid.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import InlineEditControlledEditingSrcRaw from './inline-edit-controlled-editing.story?raw';
import InlineEditControlledValueSrcRaw from './inline-edit-controlled-value.story?raw';
import InlineEditDefaultSrcRaw from './inline-edit-default.story?raw';
import InlineEditDisabledSrcRaw from './inline-edit-disabled.story?raw';
import InlineEditFluidSrcRaw from './inline-edit-fluid.story?raw';
import InlineEditHeaderSrcRaw from './inline-edit-header.story?raw';
import InlineEditNoConfirmOnBlurSrcRaw from './inline-edit-no-confirm-on-blur.story?raw';
import InlineEditWithEditIconSrcRaw from './inline-edit-with-edit-icon.story?raw';
import InlineEditWithPlaceholderSrcRaw from './inline-edit-with-placeholder.story?raw';

export const InlineEditDefaultSrc = removeLicenseHeader(
  InlineEditDefaultSrcRaw,
);
export const InlineEditHeaderSrc = removeLicenseHeader(InlineEditHeaderSrcRaw);
export const InlineEditControlledEditingSrc = removeLicenseHeader(
  InlineEditControlledEditingSrcRaw,
);
export const InlineEditWithEditIconSrc = removeLicenseHeader(
  InlineEditWithEditIconSrcRaw,
);
export const InlineEditDisabledSrc = removeLicenseHeader(
  InlineEditDisabledSrcRaw,
);
export const InlineEditWithPlaceholderSrc = removeLicenseHeader(
  InlineEditWithPlaceholderSrcRaw,
);
export const InlineEditNoConfirmOnBlurSrc = removeLicenseHeader(
  InlineEditNoConfirmOnBlurSrcRaw,
);
export const InlineEditControlledValueSrc = removeLicenseHeader(
  InlineEditControlledValueSrcRaw,
);
export const InlineEditFluidSrc = removeLicenseHeader(InlineEditFluidSrcRaw);
